import { Modal, Accordion } from "react-bootstrap";
import "./WelcomeScriptBestPractices.css";

const WelcomeScriptBestPractices = ({ setShowBestPractices, showBestPractices }: any) => {
    return (
        <Modal
            show={showBestPractices}
            onHide={() => setShowBestPractices(false)}
            centered
            dialogClassName="modal-dialog modal-dialog-centered set-width"
        >
            <Modal.Header closeButton>
                <Modal.Title>Welcome Script Best Practices</Modal.Title>
            </Modal.Header>

            <Modal.Body className="background-color">

                <div className="best-practice-banner">
                    <div className="banner-icon">⚠️</div>
                    <div>
                        <div className="banner-title">Welcome Script Best Practices</div>
                        <div className="banner-text">
                            Follow these tips to ensure your script play at right time.
                        </div>
                    </div>
                </div>

                <Accordion className="smartdocs-accordion">

                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span className="accordion-icon">🌐</span> Language Selection
                        </Accordion.Header>

                        <Accordion.Body>
                            <p>
                                <b>Language Configuration:</b> The Welcome Script language is automatically
                                determined based on the language selected by the Agent during the Enrollment process.
                            </p>

                            <div className="important-box">
                                ⚠ <b>Important:</b> Ensure the correct language is selected during enrollment,
                                as the Welcome Script will be generated using that language.
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <span className="accordion-icon">⚙️</span> Trigger Event Configuration
                        </Accordion.Header>

                        <Accordion.Body>
                            <p>
                                <b>Consistency is Recommended:</b> Once a trigger event is configured for a
                                Welcome Script, it is considered a best practice to keep the same trigger event
                                for all enrollments created under that product.
                            </p>

                            <p>
                                <b>Avoid Frequent Changes:</b> Updating the trigger event multiple times may
                                impact previously created enrollments and could result in unexpected behavior
                                or inconsistencies.
                            </p>

                            <p>
                                <b>When to Modify:</b> Trigger events should only be changed when there is a
                                strong business requirement that justifies the update.
                            </p>

                            <div className="important-box">
                                ⚠ <b>Important:</b> To ensure predictable and consistent Welcome Script behavior,
                                maintain the same trigger event configuration whenever possible.
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <span className="accordion-icon">⏱️</span> Welcome Message Trigger Execution Time
                        </Accordion.Header>

                        <Accordion.Body>
                            <p>
                                <b>Delay Duration Behavior:</b> If the delay is configured as
                                <b> 5 minutes</b>, the Welcome Message trigger is not guaranteed
                                to execute exactly after 5 minutes. Depending on system processing,
                                queueing, and scheduler timing, the trigger may execute a few
                                minutes later.
                            </p>

                            <div className="important-box">
                                ⚠ <b>Important:</b> A delay duration of 5 minutes means the trigger
                                will execute <b>after at least 5 minutes</b>. In some cases, the
                                actual execution time may be 6–7 minutes or slightly longer.
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>

            </Modal.Body>
        </Modal>
    );
};

export default WelcomeScriptBestPractices;